export class GetDeviceTreeReqData {
    folder: number;
    loadChildren: boolean;

    constructor(folder: number, loadChilder: boolean) {
        this.folder = folder;
        this.loadChildren = loadChilder;
    }
}
